module.exports = __webpack_public_path__ + "static/media/html.50cb9d4f.png";